import { Injectable } from '@angular/core';
import { LDMultiKindContext, LDSingleKindContext } from 'launchdarkly-js-sdk-common';
import { Observable } from 'rxjs';
import { FeatureFlag } from '../domain/models/feature-flags.enum';

@Injectable({
  providedIn: 'root',
})
export abstract class FeatureFlagService {
  public abstract load(): Promise<void>;
  /**
   * Get a non-observable feature flag value
   *
   * @param key: the feature flag key
   * @param defaultValue the default value
   */
  public abstract getFeature<T = boolean>(key: FeatureFlag, defaultValue: T): T;

  /**
   * Get an observable of the feature flag value that only emits once
   *
   * @param key: the feature flag key
   * @param defaultValue the default value
   */
  public abstract getFeature$<T = boolean>(key: FeatureFlag, defaultValue: T): Observable<T>;

  /**
   * Get an observable of the feature flag value that only emits once
   *
   * @param key: the feature flag key
   * @param defaultValue the default value
   */

  public abstract getLiveFeature$<T = boolean>(key: FeatureFlag, defaultValue: T): Observable<T>;
  /**
   * Identify the user/device in the launch darkly system for better targeting
   *
   * @param key: LDMultiKindContext | LDSingleKindContext
   */
  public abstract identify(user: LDMultiKindContext | LDSingleKindContext): Promise<void>;
}
